var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBeforeafterIcon = function SvgBeforeafterIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 21,
    viewBox: "0 0 38 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0598 4.9994C14.3321 5.27172 14.3321 5.71322 14.0598 5.98554L9.31399 10.7313L14.0598 15.4772C14.3321 15.7495 14.3321 16.191 14.0598 16.4633C13.7875 16.7356 13.346 16.7356 13.0737 16.4633L7.83479 11.2244C7.56248 10.9521 7.56248 10.5106 7.83479 10.2383L13.0737 4.9994C13.346 4.72709 13.7875 4.72709 14.0598 4.9994Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5702 4.99916C24.2979 5.27147 24.2979 5.71298 24.5702 5.98529L29.316 10.7311L24.5702 15.4769C24.2979 15.7492 24.2979 16.1907 24.5702 16.463C24.8425 16.7354 25.2841 16.7354 25.5564 16.463L30.7952 11.2242C31.0676 10.9519 31.0676 10.5103 30.7952 10.238L25.5564 4.99916C25.2841 4.72684 24.8425 4.72684 24.5702 4.99916Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBeforeafterIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/beforeafter-icon.44c02d3b999cd69ed6dd21c3ba18fc84.svg";